import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  arrow: {
    color: '#079cb2',
  },
});

const CustomPrevArrow = (props: any) => {
  const { className, style, onClick } = props;
  const classes = useStyles();
  return (
    <IconButton
      className={className} 
      sx={{ ...style, height:"100%", display:'flex', alignItems:"center",
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: 'transparent',
        },
      }}
      onClick={onClick}
    >
      <ArrowBackIcon className={classes.arrow} />
    </IconButton>
  );
};

export default CustomPrevArrow;
